
























































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import SocketIOConnecter from "@/modules/sockets/sockets-module";
import Progress from "./progress.vue";
import { splitString } from "@/services/strings";
import { type } from "@/config/files.config.json";
import { getWebImage } from "@/config/host.config";

@Component({
  mixins: [SocketIOConnecter],
  components: { "progress-component": Progress },
})
export default class UploadingVideoToServer extends Mixins(SocketIOConnecter) {
  @Prop({ type: String, default: "" }) videoName!: string;
  @Prop({ type: String, default: "video" }) upload!: string;
  @Prop({ type: String, default: "" }) uri!: string;
  @Prop({ type: String, default: "" }) path!: string;
  @Prop({ type: Boolean, default: true }) showName!: boolean;

  show = true;
  straightPictures = getWebImage;

  $refs!: {
    uploadBox: HTMLInputElement;
    nameBox: HTMLInputElement;
    fileBox: HTMLInputElement;
    uploadButton: HTMLButtonElement;
  };

  @Watch("fileName")
  updateFileName(): void {
    if (this.fileName === null || this.fileName === undefined) return;
    this.$emit("changeVideoName", this.fileName);
  }

  fileChosen(): void {
    this.selectedFile = this.$refs.fileBox.files
      ? this.$refs.fileBox.files[0]
      : null;

    if (!this.selectedFile) {
      alert("Файл не выбран");
      if (this.$refs.nameBox) this.$refs.nameBox.value = "";
      return;
    }
    console.log(this.selectedFile.type);
    if (!this.getFileFormat(this.selectedFile.type.toLowerCase())) {
      this.selectedFile = null;
      if (this.$refs.nameBox) this.$refs.nameBox.value = "";
      alert("Неподходящий формат");
      return;
    }

    if (!this.fileName) this.fileName = this.selectedFile.name;
    this.$emit("changeType", this.selectedFile.type);
    this.$emit("changeVideoName", this.fileName);
    this.connect(this.uri, this.upload, this.path);
    this.startUpload(this.selectedFile.size);
  }

  getFileFormat(string: string | undefined): boolean {
    const space = "/";
    const format = this.upload == "video" ? type.video : type.audio;
    if (string === undefined) return false;
    const splitArr = splitString(string, space);
    return format.includes(splitArr[splitArr.length - 1]);
  }

  @Watch("videoName")
  start(): void {
    if (this.videoName) this.fileName = this.videoName;
    if (!window.File || !window.FileReader) {
      this.show = false;
      return;
    }
  }

  mounted(): void {
    this.$nextTick(() => {
      this.start();
    });
  }
}
